export default {"src":"/_next/static/media/eye-slash.24dbcc5f.svg","height":13,"width":16,"blurWidth":0,"blurHeight":0};